// import React, { useState } from "react";
// import { deleteCampaign } from "../../../../services/communication.services"; // Import the service functions

// const EditDelete = ({ campaignId, onCampaignDelete, setIsEditing }) => {
//   const [isOpen, setIsOpen] = useState(false); // For toggling the menu open/close

//   // Toggle the menu open/close
//   const toggleMenu = () => setIsOpen(!isOpen);

//   // Handle Delete Campaign
//   const handleDelete = async () => {
//     try {
//       // Call the deleteCampaign service with the campaignId
//       const response = await deleteCampaign(campaignId);
//       "Campaign Deleted: ", response);

//       // Notify parent component (if required)
//       onCampaignDelete(campaignId);
//       setIsOpen(false); // Close the menu after deleting
//     } catch (error) {
//       console.error("Error deleting campaign:", error.message);
//     }
//   };
//   const handleEdit = () => {
//     setIsEditing(true); // Start editing mode
//   };
//   return (
//     <div className="relative">
//       <button
//         onClick={toggleMenu}
//         className="p-2 bg-gray-100 rounded-full hover:bg-gray-200"
//       >
//         {/* Vertical Dots Icon */}
//         <svg
//           xmlns="http://www.w3.org/2000/svg"
//           fill="none"
//           viewBox="0 0 24 24"
//           strokeWidth="1.5"
//           stroke="currentColor"
//           className="w-6 h-6 text-gray-600"
//         >
//           <path
//             strokeLinecap="round"
//             strokeLinejoin="round"
//             d="M12 6.75a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm0 5.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm0 5.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0z"
//           />
//         </svg>
//       </button>

//       {isOpen && (
//         <div className="absolute right-0 mt-2 w-48 bg-white border border-gray-300 rounded-lg shadow-lg">
//           <div className="flex justify-between">
//             <button
//               onClick={handleEdit}
//               className="block px-4 py-2 text-sm text-blue-600 hover:bg-gray-100 w-full text-left"
//             >
//               Edit
//             </button>
//             <span className="border-l border-gray-300 mx-2"></span>
//             <button
//               onClick={handleDelete}
//               className="block px-4 py-2 text-sm text-red-600 hover:bg-gray-100 w-full text-left"
//             >
//               Delete
//             </button>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default EditDelete;
import { useState, useRef, useEffect } from "react";
import { deleteCampaign } from "../../../../services/communication.services";

const EditDelete = ({ campaignId, onCampaignDelete, setEditingId }) => {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null); // for detecting outside click

  const toggleMenu = () => setIsOpen(!isOpen);

  const handleDelete = async () => {
    try {
      await deleteCampaign(campaignId);
      onCampaignDelete(campaignId);
      setIsOpen(false);
    } catch (error) {
      console.error("Error deleting campaign:", error.message);
    }
  };

  const handleEdit = () => {
    setEditingId(campaignId);
    setIsOpen(false);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  return (
    <div className="relative" ref={menuRef}>
      <button
        onClick={toggleMenu}
        className="p-2 bg-gray-100 rounded-full hover:bg-gray-200"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="1.5"
          stroke="currentColor"
          className="w-6 h-6 text-gray-600"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M12 6.75a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm0 5.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm0 5.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0z"
          />
        </svg>
      </button>

      {isOpen && (
        <div className="absolute right-0 mt-2 w-48 bg-white border border-gray-300 rounded-lg shadow-lg z-50">
          <button
            onClick={handleDelete}
            className="block px-4 py-2 text-sm text-red-600 hover:bg-gray-100 w-full text-left"
          >
            Delete
          </button>
        </div>
      )}
    </div>
  );
};

export default EditDelete;
